import { render } from "./UserManagementLayout.vue?vue&type=template&id=1766f18d&scoped=true"
import script from "./UserManagementLayout.vue?vue&type=script&lang=js"
export * from "./UserManagementLayout.vue?vue&type=script&lang=js"

import "./UserManagementLayout.vue?vue&type=style&index=0&id=1766f18d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1766f18d"]])

export default __exports__